import React from "react";
import Header from "../components/header/Header";
import Sidebar from "../components/sidebar/Sidebar";
import { Outlet } from "react-router-dom";

const DashboardLayout = () => {
  return (
    <>
      <div className="w-full flex h-screen">
        <div className="w-1/6 fixed border-r-1 z-50">
          <Sidebar />
        </div>
        <div className="w-full h-full flex">
          <div className="w-1/6"></div>
          <div className="w-5/6 h-full">
            <div className="border-b-1 ">
              <Header />
            </div>
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardLayout;
